import { useCallback } from 'react';
import { RUMHelpers } from 'services/observability/datadog';
import { Product, Team } from 'teams';
import { DragAndDropEditorError, TrackErrorConfig } from '../types';
import { isAuthTokenUnexpired } from '../utils';

export const useTrackDragAndDropEditorRUMError = () => {
  return useCallback(function trackDnDRUMError({
    token,
    error: componentError = new Error(),
    errorMessage,
    errorName = DragAndDropEditorError.DRAG_AND_DROP_EDITOR_UNKNOWN_ERROR,
    productName = Product.DRAG_AND_DROP_EDITOR,
    teamName = Team.CAMPAIGN_TEAM,
  }: TrackErrorConfig) {
    const authTokenIsDefined = !!token?.access_token;

    RUMHelpers.addRUMError(
      componentError,
      {
        name: errorName,
        productName,
        teamName,
      },
      {
        authTokenExpiration: new Date(token?.['.expires'] as string).toString(),
        authTokenIsDefined,
        authTokenIsExpired: !isAuthTokenUnexpired(token),
        authTokenIssued: new Date(token?.['.issued'] as string).toString(),
        currentDateTime: new Date().toString(),
        errorMessage,
        errorName,
        productName,
        teamName,
      },
    );
  }, []);
};
